{
  "nl": {
    "startPage": {
      "collections": {
        "timedLabel": "Nu aanmelden",
        "timedTitle": "Gratis adventskalender met 24 inspiraties"
      },
      "ctaBanner": {
        "aiDSGVOCompliant": {
          "checklist": {
            "1": "Leerlingtoegang tot AI-Chat, Rollen-Chatbot, PDF-Chat, Afbeelding genereren, Tekstbewerker en AI Multimedia Tool",
            "2": "Registratie van je leerlingen is niet nodig",
            "3": "Automatische verwijdering na 24 uur<br><a href=\"{href}\" target=\"_blank\">Meer informatie</a>"
          },
          "text": "Met de fobizz Klassenräume krijgen je leerlingen hun eigen toegang tot de <b>fobizz AI-Assistentie</b> en kunnen ze er <b>AVG-conform</b> mee werken.",
          "title": "Klassenräume: AI-Assistentie AVG-conform gebruiken met leerlingen"
        },
        "simpleAndSecure": {
          "checklist": {
            "1": "Eenvoudig & veilig",
            "2": "AVG-conform",
            "3": "Innovatief: de nieuwste tools om de les nog beter en gevarieerder te maken"
          },
          "subline": "Fobizz AI-Assistentie voor nog snellere planning",
          "sublinePrefix": "Incl. AI",
          "text": "Alle handige tools voor het plannen en uitvoeren van lessen op één plek.",
          "title": "Digitaal onderwijs eenvoudig en veilig vormgeven"
        },
        "startFree": "Nu gratis starten"
      },
      "headers": {
        "assistants": "AI-Assistenten voor Jou",
        "assistantsBadge": "150+ Chatbots",
        "continueWorkshops": "Verdergaan",
        "favoriteTools": "Favoriete Tools",
        "miniTools": "Populaire Prompts",
        "miniToolsBadge": "55+ Prompts",
        "myAssistants": "Mijn Assistenten",
        "newAssistants": "Nieuwe Assistenten",
        "recommendationsForYou": "Aanbevelingen voor jou",
        "recommendedWorkshops": "Aanbevelingen voor jou",
        "savedCourses": "Opgeslagen Cursussen",
        "savedMaterial": "Opgeslagen Materiaal",
        "sectionChatTools": "AI-Chat en Assistenten",
        "sectionFeedbackTools": "AI-Feedback en Beoordeling",
        "sectionMaterialTools": "Materiaal maken",
        "sectionMaterials": "Lesmateriaal gebruiken",
        "sectionMultimediaTools": "AI voor Mediacreatie",
        "sectionOnboarding": "Jouw start met fobizz",
        "sectionShareTools": "Inhoud veilig delen",
        "sectionWorkshops": "Ontdek trainingen",
        "videoOnboarding": "fobizz in 100 seconden",
        "yourWorkshops": "Actuele live-webinars en workshops"
      },
      "hiddenFeedbackTools": {
        "badge": "Waar zijn de tools?",
        "tooltip": "Deze tools zijn standaard verborgen en kunnen op verzoek op schoolniveau worden geactiveerd."
      },
      "howTo": {
        "bookmarkTeaserHeadline": "Cursussen en inhoud opslaan voor later",
        "bookmarkTeaserLinkCourses": "Opgeslagen Trainingen",
        "bookmarkTeaserLinkMaterial": "Opgeslagen Materiaal",
        "bookmarkTeaserText": "Sla trainingen en materialen op met een klik op het hart en vind ze gemakkelijk terug op je verlanglijst.",
        "materialTeaserHeadline": "Delen is zorgen: materiaal samen gebruiken",
        "materialTeaserLink": "Bekijk tutorial",
        "materialTeaserText": "Al het materiaal valt onder de CC-BY-licentie. Via Remix kun je het gratis kopiëren, aanpassen en verder gebruiken.",
        "materialTeaserTextCommunity": "Al het materiaal valt onder de CC-BY-licentie. Via Remix kun je het gratis kopiëren en aanpassen. Controleer vooraf kritisch de inhoud en links, ook met betrekking tot auteursrecht en gegevensbescherming.",
        "materialTeaserVideoId": "1085940798",
        "materialTeaserVideoTitle": "Materialen aanmaken en delen"
      },
      "links": {
        "assistantsCatalog": "Meer Assistenten Ontdekken",
        "createClass": "Klassenraum aanmaken",
        "hideOnboarding": "Start met fobizz verbergen",
        "miniToolsCatalog": "Meer Prompts Ontdekken",
        "toAssistantsCatalog": "Alles tonen",
        "toMaterials": "Alles tonen",
        "toMyAssistantsCatalog": "Alles tonen",
        "toSavedMaterials": "Jouw verlanglijst",
        "toSavedWorkshops": "Jouw verlanglijst",
        "toTools": "Alle tools tonen",
        "toWorkshops": "Alle trainingen",
        "watchTutorial": "Bekijk tutorial"
      },
      "onboarding": {
        "videoId": "1085940572",
        "videoTitle": "fobizz in 100 seconden"
      },
      "paragraphs": {
        "mySchoolClassesDisabled": "De Klassenräume zijn uitgeschakeld voor jouw licentiegroep. Neem voor meer informatie contact op met de persoon die de licentie beheert.",
        "onboarding": "Ontdek je mogelijkheden bij fobizz - kort en bondig, als compacte introductie of begin meteen met je eerste cursus.",
        "recommendationsAndProfile": "Deze instellingen worden ook overgenomen voor je <a href=\"{href}\" target=\"_blank\">profiel</a>.",
        "recommendationsForYou": "We raden je inhoud aan op basis van je profielinstellingen en je reeds gevolgde of opgeslagen cursussen of materialen."
      },
      "schoolClasses": {
        "videoId": "1085940985",
        "videoTitle": "fobizz Klassenräume in 30 seconden"
      },
      "toolTips": {
        "recommendationsForYou": "Hier kun je instellen voor welke onderwerpen je aanbevelingen wilt zien"
      },
      "tools": {
        "experimental": "Experimenteel",
        "headers": {
          "title": "Gebruik handige digitale tools met AI-integratie"
        }
      },
      "toolsModal": {
        "configureTooltip": "Hier kun je je favoriete tools instellen",
        "selectFavoriteTools": "Stel je <strong>favoriete tools</strong> in voor je snelle toegang:",
        "validation": {
          "minTools": "Je moet minimaal 1 tool selecteren"
        }
      },
      "webinar": {
        "accessLinkLater": "De toegangslink verschijnt later hier",
        "certificateLater": "Je certificaat verschijnt later hier",
        "enrolled": "Ingeschreven",
        "participated": "Deelgenomen",
        "percentComplete": "{percent}% voltooid",
        "reserveSpot": "Nu plek reserveren",
        "toCertificate": "Naar certificaat",
        "toLiveWebinar": "Naar live-webinar"
      }
    }
  }
}
